import React from 'react';
import PropTypes from 'prop-types';
import { QueryRenderer, graphql } from 'react-relay';
import RelayService from "../service/RelayService";
import CategoryMenu from './CategoryMenu';
import Loading from '../ui/Loading';
import AppConfigService from '../service/AppConfigService';
import type AppConfig from '../domain/AppConfig';
import AppService from '../service/AppService';

let query = graphql`
    query CategoryMenuLoaderQuery($langCode:String, $sellerFlag:Boolean) {
        productCategories(langCode:$langCode, sellerFlag:$sellerFlag) {
            ...CategoryMenu_productCategories
        }
    }
`;

export default class CategoryMenuLoader extends React.Component {

  static propTypes = {
    viewer: PropTypes.shape({
      disableMarketplaceBanner: PropTypes.bool,
    }),
  };

  render() {

    let appConfig:AppConfig = AppService.appConfig();
    let locale = appConfig.langCode;
    let disableMarketplaceBanner = this.props.disableMarketplaceBanner;

    let sellerFlag = false;
    if (AppConfigService.shouldShowMarketplaceTopBanner() || !disableMarketplaceBanner) {
      sellerFlag = true;
    }

    return (

        <QueryRenderer
          environment={RelayService.environment}
          query={query}
          variables={{
            langCode: locale,
            sellerFlag
          }}
          render={({ error, props }) => {
            if (error) {
              return <div>{error.message}</div>;
            } else if (props) {
              return (
                <CategoryMenu productCategories={props.productCategories} {...this.props} />
              );
            }
            return (
              <div id="categoryMenu">
                <Loading />
              </div>
          );
          }}
        />


    )
  }

}